import "./CustomHeader.less"
import Images from "../../utils/Images";
import { ColorImg } from "../ColorImg/ColorImg";
import getStoreFromProps from "../../store/getStoreFromProps";
import { inject, observer } from "mobx-react";
import { Logout } from "../Logout/Logout";
import { useState } from "react";

type CustomHeaderProps = {
    onTrainManageBtnClick: () => void;
};

export const CustomHeader = inject("common")(observer((props: CustomHeaderProps): React.ReactElement => {
    const commonStore = getStoreFromProps(props, "common");
    const isLogin = commonStore.getIsLogin();
    const [isTrainManageVisible, setIsTrainManageVisible] = useState(false);

    const login = (): React.ReactElement => {
        return <div className="custom-header-login" onClick={commonStore.toLoginPage}>登录</div>;
    };

    const headImg = (): React.ReactElement => {
        return <Logout>
            <div className="custom-header-login">
                <img src={commonStore.getAvatar()}></img>
            </div>
        </Logout>;
    };

    return <div className="custom-header">
        <img className="custom-header-logo" src={Images.logo}></img>
        <div className="custom-header-hint" onClick={props.onTrainManageBtnClick}>
            <img src={Images.headerImg}></img>
            <span>训练管理</span>
        </div>
        <div className="custom-header-line"></div>
        {/* <div className="custom-header-coins">
            <ColorImg src={Images.coins}></ColorImg>
            <span>{commonStore.getTotalCoins()}</span>
        </div> */}
        {isLogin ? headImg() : login()}
    </div>;
}));